export const mapConfigDominationLiteral = [
  {
    type: 'captureMode',
    id: 'cm_3v3_tutorial',
    assetName: 'domination-tutorial-map',
    name: 'loc:::map_config_zone_rush_tutorial_name',
    teamCount: 1,
    teamSize: 0,
    gamePlayConfig: {
      matchDuration: 1000 * 60 * 5,
      pointsMax: 100,
      updatePointsInterval: 1000,
      minionSpawnRadius: 250,
      minionSpawnEachWave: 0,
      minionWaveCooldown: 30000,
      minionCapPerTeam: 15,
      minionCapPerObjective: 8,
      pointsPerTick: 0.5,
      pointsPerTickDominated: 1
    },
    uiConfigs: {
      countDownTimes: 5,
      matchStartUiDelay: 3000,
      matchStartSoonUiDuration: 2000,
      countdownInterval: 1000,
      matchBeginDisplayDuration: 2000,
      playerDisconnectDisplayDuration: 5000,
      miniMap: {
        textureName: 'mini_map_3v3',
        bgFrame: 'map-base',
        gameMapDimensions: {
          width: 9510,
          height: 5788
        },
        entityZIndex: {
          dm_objective: 1,
          tower: 2,
          minion: 3,
          bot: 4
        }
      }
    },
    lobbyConfig: {
      title: 'loc:::map_config_tutorial',
      subtitle: 'loc:::solo',
      dataKey: 'captureModeLobby'
    }
  },
  {
    type: 'captureMode',
    id: 'cm_3v3_coop',
    assetName: 'domination-map',
    name: 'loc:::game_list_zonerush_name',
    teamCount: 2,
    teamSize: 3,
    afkTimer: 60000,
    humanOpponents: false,
    gamePlayConfig: {
      matchDuration: 1000 * 60 * 5,
      pointsMax: 100,
      updatePointsInterval: 1000,
      minionSpawnRadius: 250,
      minionSpawnEachLane: 1,
      minionSpawnGroupsEachWave: 3,
      minionSpawnGroupCooldown: 1400,
      minionWaveCooldown: 30000,
      minionCapPerTeam: 15,
      minionCapPerObjective: 8,
      pointsPerTick: 0.5,
      pointsPerTickDominated: 1
    },
    uiConfigs: {
      countDownTimes: 5,
      matchStartUiDelay: 3000,
      matchStartSoonUiDuration: 2000,
      countdownInterval: 1000,
      matchBeginDisplayDuration: 2000,
      playerDisconnectDisplayDuration: 5000,
      miniMap: {
        textureName: 'mini_map_3v3',
        bgFrame: 'map-base',
        gameMapDimensions: {
          width: 9510,
          height: 5788
        },
        entityZIndex: {
          dm_objective: 1,
          tower: 2,
          minion: 3,
          bot: 4
        }
      }
    },
    lobbyConfig: {
      title: 'loc:::coopVsAi',
      subtitle: 'loc:::solo',
      dataKey: 'captureModeLobby',
      unlockTooltip: 'loc:::completeTutorialToUnlock'
    }
  },
  {
    type: 'captureMode',
    id: 'cm_3v3_pvp',
    assetName: 'domination-map',
    name: 'loc:::game_list_zonerush_name',
    teamCount: 2,
    teamSize: 3,
    afkTimer: 60000,
    humanOpponents: true,
    gamePlayConfig: {
      matchDuration: 1000 * 60 * 5,
      pointsMax: 100,
      updatePointsInterval: 1000,
      minionSpawnRadius: 250,
      minionSpawnEachLane: 1,
      minionSpawnGroupsEachWave: 3,
      minionSpawnGroupCooldown: 1400,
      minionWaveCooldown: 30000,
      minionCapPerTeam: 15,
      minionCapPerObjective: 8,
      pointsPerTick: 0.5,
      pointsPerTickDominated: 1
    },
    uiConfigs: {
      countDownTimes: 5,
      matchStartUiDelay: 3000,
      matchStartSoonUiDuration: 2000,
      countdownInterval: 1000,
      matchBeginDisplayDuration: 2000,
      playerDisconnectDisplayDuration: 5000,
      miniMap: {
        textureName: 'mini_map_3v3',
        bgFrame: 'map-base',
        gameMapDimensions: {
          width: 9510,
          height: 5788
        },
        entityZIndex: {
          dm_objective: 1,
          tower: 2,
          minion: 3,
          bot: 4
        }
      }
    },
    lobbyConfig: {
      title: 'loc:::pvp',
      subtitle: 'loc:::solo',
      dataKey: 'captureModeLobby',
      unlockTooltip: 'loc:::completeTutorialToUnlock'
    }
  }
] as const;
